import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledEditableText, StyledErrorCard } from './styles';
import { KizenTypography } from '__app/typography';
import { Overlay } from 'react-bootstrap2';
import { useFlashTransition } from '__hooks/useFlashState';
import { useTruncationTooltip } from '__components/Kizen/Tooltip';

const MAX_NAME_LENGTH = 500;

export const SmartConnectorNameInput: FC<{
  value: string;
  error?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
}> = ({ value, error, onChange, onBlur, disabled }) => {
  const ref = useRef<HTMLDivElement>();
  const { t } = useTranslation();

  const [, showErrorMessage, flashError, cancelFlash] = useFlashTransition();
  const [tooltipProps, tooltip] = useTruncationTooltip();
  const [editing, setEditing] = useState(false);

  const handleFocus = () => {
    setEditing(true);
  };

  const handleBlur = () => {
    setEditing(false);
    onBlur();
  };

  const onChangeName = (value: string) => {
    onChange(value);
    cancelFlash();
  };

  useEffect(() => {
    if (error) {
      flashError(error);
    }
  }, [error, flashError]);

  return (
    <div ref={(el: HTMLDivElement) => (ref.current = el)}>
      {!editing && tooltip}
      <StyledEditableText
        value={value}
        onChange={onChangeName}
        placeholder={t('SmartConnector Name')}
        error={!!error}
        disabled={disabled}
        {...tooltipProps}
        onFocus={handleFocus}
        onBlur={handleBlur}
        data-qa={`smartconnector-name`}
        maxLength={MAX_NAME_LENGTH}
      />
      <Overlay
        transition={!error}
        target={ref.current!}
        show={showErrorMessage}
        placement="bottom-start"
      >
        <StyledErrorCard show={!!error}>
          <KizenTypography>{error}</KizenTypography>
        </StyledErrorCard>
      </Overlay>
    </div>
  );
};
